import { render, staticRenderFns } from "./Regency.vue?vue&type=template&id=764096d3&scoped=true&"
import script from "./Regency.vue?vue&type=script&lang=js&"
export * from "./Regency.vue?vue&type=script&lang=js&"
import style0 from "./Regency.vue?vue&type=style&index=0&id=764096d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764096d3",
  null
  
)

export default component.exports